import { Button, Dialog, Divider, Rating, TextField, Pagination, Chip } from "@mui/material";
import Box from "elements/Box";
import { ApiRequest } from "GlobalFunctions";
import { useEffect, useState } from "react";
import { GoLog } from "react-icons/go";
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';

export default function OrdersUsers() {

    const [orders, setOrders] = useState([]);
    const [page, setPage] = useState(1);
    const [total_pages, setTotalPages] = useState(0);

    const loadOrders = async () => {
        ApiRequest({
            url: '/orders/usersList',
            method: 'GET',
            query: { 
                page 
            },
            setResponse: (response: any) => {
                setOrders(response.list || []);
                setTotalPages(response.total_pages || 0);
            }
        });
    }

    useEffect(() => {
        loadOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const [comment, setComment] = useState('');
    const [ratingValue, setRatingValue] = useState(0);
    const [orderId, setOrderId] = useState(0);
    const [openComment, setOpenComment] = useState(false);

    const handleRating = () => {
        ApiRequest({
            url: '/orders/updateRating',
            method: 'POST',
            body: {
                order_id: orderId,
                rating_value: ratingValue,
                comment
            },
            setResponse: (response: any) => {
                setOpenComment(false);
                loadOrders();
            }
        });
    }

    return(
        <div className='account_users_services'>
            <h2 className="contract_title"><GoLog /> Contratos</h2>

            <div className="contract_user_container">
                {orders.length > 0 ? orders.map((item: any, index: number) => {
                    
                    const service = item.service || 'Atención kinesiológica';
                    
                    let orderStatus: string, chipColor: "default" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
                    switch (item.order_status) {
                        case 'pending':
                            orderStatus = 'Pendiente';
                            chipColor = 'default';
                            break;
                        case 'approved':
                            orderStatus = 'Aprobado';
                            chipColor = 'primary';
                            break;
                        case 'rejected':
                            orderStatus = 'Rechazado';
                            chipColor = 'error';
                            break;
                        default:
                            orderStatus = 'Finalizado';
                            chipColor = 'success';
                    }

                    return (
                    <Box key={index} className='contract_item'>
                        <div className="contract_header">
                            <h2 className="contract_service">{service}</h2>
                            <div className="contract_row">
                                <span className="contract_comuna">{item.comuna_name}</span>
                                <span className="contract_date">{item.order_date}</span>
                            </div>
                            
                        </div>
                        <Divider />
                        <div className="contract_body">
                            <h2 className="contract_service">Por: {item.buyer_name}</h2>
                            <Chip className="chipStatus" label={orderStatus} color={chipColor} variant="outlined" size="small" style={{ flexShrink: 0 }} />
                            <span className="contract_data"><b>Dir:</b> {item.address}</span>
                            <span className="contract_data"><b>Tel:</b> {item.phone}</span>
                            <span className="contract_data"><b>Comentarios:</b> {item.comments}</span>     

                            {!item.rating_id && item.order_status === "finished" && (
                                <>
                                    <h2>Califica</h2>
                                    <Rating 
                                        value={item.rating_value || 0} 
                                        readOnly={item.rating_id ? true : false}
                                        icon={<StarRateRoundedIcon fontSize="inherit" />}
                                        emptyIcon={<StarRateRoundedIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                                        onChange={(event, newValue) => {
                                            setRatingValue(Number(newValue));
                                            setOrderId(item.order_id);
                                            setOpenComment(true);
                                        }}
                                    />
                                </>
                            )}
                            
                        </div>

                        
                    </Box>
                )}) : (
                    <p>No tienes servicios</p>
                )}
            </div>
            {total_pages > 1 && (
                <Pagination 
                    count={total_pages} 
                    page={page}  
                    onChange={(event, value) => {
                        setPage(value);
                    }} 
                    color="primary"
                    style={{"marginTop": "20px","alignSelf": "center"}}
                />
            )}
            <Dialog
                open={openComment}  
                onClose={() => setOpenComment(false)}
            >
                <div className="DialogContainer" style={{ maxWidth: '502px' }}>
                    <div className="ModuleWrapper">
                        <div className="ModuleHeader">
                            <h2>Calificar</h2>
                            <p>Deja tu comentario</p>
                            <TextField
                                label="Comentario"
                                onChange={(e) => setComment(e.target.value)}
                                variant="outlined"
                                fullWidth
                                multiline
                                style={{ width: '300px' }}
                            />
                        </div>
                        <div className="rating_buttons">
                            <Button fullWidth onClick={() => setOpenComment(false)} variant="outlined">Cancelar</Button>
                            <Button fullWidth onClick={handleRating} variant="contained">Calificar</Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}